import { IBlock } from "../../../framework/src/IBlock";
import { Message } from "../../../framework/src/Message";
import { BlockComponent } from "../../../framework/src/BlockComponent";
import MessageEnum, {
  getName,
} from "../../../framework/src/Messages/MessageEnum";
import { runEngine } from "../../../framework/src/RunEngine";
// Customizable Area Start
import { getStorageData } from "../../../framework/src/Utilities";
import { IUserContext } from "../../../blocks/navigationmenu/src/PageContainerController.web";
import {
  PermissionStatus,
  checkForNewPermissonStatus,
  customPermissionApiKey
} from "../../../blocks/utilities/src/CustomBlockHelpers";
import { PermissionGroupArray } from "../../../blocks/navigationmenu/src/utils";

export interface IRuleTypeOption {
  id: string;
  type: string;
  attributes: {
    id: number;
    name: string;
    code: string;
    description: string;
    is_active: boolean;
    created_at: string;
    updated_at: string;
    rules_count: number;
    active_rules_count: number;
  };
}

export const configJSON = require("./config");

export interface Props {
  navigation: {
    navigate: (routeName: string) => void;
    goBack: () => void;
    history: {
      push: (path: string) => void;
    };
  };
  id: string;
}

interface MultiplierFormData {
  name: string;
  description: string;
  multiplier: string;
  loyalty_multiplier_rule_type_id: string;
  start_date: string;
  end_date: string;
  // Type 1 & 2: Days of week
  selected_days: number[];
  // Type 1: Day time config
  start_time: string;
  end_time: string;
  // Type 2: Late delivery config
  delay_hours: string;
  // Type 3: Special day config
  special_day_name: string;
  special_day_date: string;
  is_recurring: boolean;
  // Type 4: Upcharge config
  upcharge_list_id: string;
  requires_all_items: boolean;
  // Location and platform filters
  platform_ids: number[];
  region_ids: number[];
  area_ids: number[];
  store_ids: number[];
}

interface IOption {
  id: string | number;
  option: string;
}

interface IUpchargeList {
  id: string;
  type: string;
  attributes: {
    name: string;
    second_name: string;
    price: number;
    upcharge_type: string;
    active: boolean;
  };
}

interface IPlatform {
  id: string;
  type: string;
  attributes: {
    id: number;
    name: string;
    created_at: string;
    updated_at: string;
  };
}

interface IRegion {
  id: string;
  type: string;
  attributes: {
    id: number;
    branch_name: string;
    name: string;
  };
}

interface IArea {
  id: string;
  type: string;
  attributes: {
    id: number;
    area_name: string;
  };
}

interface IStore {
  id: string;
  type: string;
  attributes: {
    id: number;
    store_name: string;
    use_raw_printing_receipt: boolean;
    enabled_b2b_order: boolean;
    enabled_b2c_order: boolean;
    name_translation: string;
  };
}

interface S {
  formData: MultiplierFormData;
  formErrors: { [key: string]: string };
  ruleTypes: IRuleTypeOption[];
  snackBarMessage: string;
  snackBarMessageType: "error" | "success" | "info" | "warning" | undefined;
  permissionStatus: PermissionStatus;
  isLoadingPermission: boolean;
  isSubmitting: boolean;
  // Section multi-select state
  sectionList: IOption[];
  sectionSelectedData: IOption[];
  selectedSectionsForList: IOption[];
  isSectionSelectAll: boolean;
  // Catalogue multi-select state
  catalogueList: IOption[];
  catalogueSelectedData: IOption[];
  selectedCataloguesForList: IOption[];
  isCatalogueSelectAll: boolean;
  // Days of week multi-select state
  daysOfWeekList: IOption[];
  selectedDaysOfWeek: IOption[];
  selectedDaysOfWeekForList: IOption[];
  // Upcharge list
  upchargeList: IUpchargeList[];
  // Platform multi-select state
  platformList: IPlatform[];
  platformSelectedData: IOption[];
  selectedPlatformsForList: IOption[];
  isPlatformSelectAll: boolean;
  // Region multi-select state
  regionList: IRegion[];
  regionSelectedData: IOption[];
  selectedRegionsForList: IOption[];
  isRegionSelectAll: boolean;
  // Area multi-select state
  areaList: IArea[];
  areaSelectedData: IOption[];
  selectedAreasForList: IOption[];
  isAreaSelectAll: boolean;
  // Store multi-select state
  storeList: IStore[];
  storeSelectedData: IOption[];
  selectedStoresForList: IOption[];
  isStoreSelectAll: boolean;
  // Loading state
  isLoading: boolean;
  ruleId: string;
}

interface SS {
  id: number | string;
}

const emptyFormData: MultiplierFormData = {
  name: "",
  description: "",
  multiplier: "",
  loyalty_multiplier_rule_type_id: "",
  start_date: "",
  end_date: "",
  // Type 1 & 2
  selected_days: [],
  // Type 1
  start_time: "",
  end_time: "",
  // Type 2
  delay_hours: "",
  // Type 3
  special_day_name: "",
  special_day_date: "",
  is_recurring: false,
  // Type 4
  upcharge_list_id: "",
  requires_all_items: true,
  // Location and platform filters
  platform_ids: [],
  region_ids: [],
  area_ids: [],
  store_ids: [],
};

export default class EditLoyaltyMultiplierController extends BlockComponent<Props, S, SS> {
  updateMultiplierCallId: string = "";
  getRuleTypesCallId: string = "";
  getSectionsCallId: string = "";
  getCataloguesCallId: string = "";
  getUpchargeListsCallId: string = "";
  getMultiplierRuleCallId: string = "";
  getPlatformsCallId: string = "";
  getRegionsCallId: string = "";
  getAreasCallId: string = "";
  getStoresCallId: string = "";

  // Catalogue pagination
  catalogueNextPage: number = 1;
  isLoadingMoreCatalogues: boolean = false;
  hasMoreCatalogues: boolean = true;
  catalogueSearchQuery: string = "";

  constructor(props: Props) {
    super(props);
    this.receive = this.receive.bind(this);

    this.subScribedMessages = [
      getName(MessageEnum.AccoutLoginSuccess),
      getName(MessageEnum.RestAPIResponceSuccessMessage),
      getName(MessageEnum.RestAPIResponceDataMessage),
      getName(MessageEnum.RestAPIResponceMessage),
      getName(MessageEnum.LayoutDataMessage),
    ];

    this.state = {
      formData: { ...emptyFormData },
      formErrors: {},
      ruleTypes: [],
      snackBarMessage: "",
      snackBarMessageType: "success",
      permissionStatus: {
        mainPermission: false,
        createPermission: false,
        viewPermission: false,
        editPermission: false,
        deactivatePermission: false
      },
      isLoadingPermission: true,
      isSubmitting: false,
      // Section multi-select state
      sectionList: [],
      sectionSelectedData: [],
      selectedSectionsForList: [],
      isSectionSelectAll: false,
      // Catalogue multi-select state
      catalogueList: [],
      catalogueSelectedData: [],
      selectedCataloguesForList: [],
      isCatalogueSelectAll: false,
      // Days of week multi-select state
      daysOfWeekList: [
        { id: 0, option: "Sunday" },
        { id: 1, option: "Monday" },
        { id: 2, option: "Tuesday" },
        { id: 3, option: "Wednesday" },
        { id: 4, option: "Thursday" },
        { id: 5, option: "Friday" },
        { id: 6, option: "Saturday" },
      ],
      selectedDaysOfWeek: [],
      selectedDaysOfWeekForList: [],
      // Upcharge list
      upchargeList: [],
      // Platform multi-select state
      platformList: [],
      platformSelectedData: [],
      selectedPlatformsForList: [],
      isPlatformSelectAll: false,
      // Region multi-select state
      regionList: [],
      regionSelectedData: [],
      selectedRegionsForList: [],
      isRegionSelectAll: false,
      // Area multi-select state
      areaList: [],
      areaSelectedData: [],
      selectedAreasForList: [],
      isAreaSelectAll: false,
      // Store multi-select state
      storeList: [],
      storeSelectedData: [],
      selectedStoresForList: [],
      isStoreSelectAll: false,
      // Loading state
      isLoading: true,
      ruleId: "",
    };
    runEngine.attachBuildingBlock(this as IBlock, this.subScribedMessages);
  }

  receiveUpdateMultiplier = (message: Message) => {
    const responseJson = message.getData(
      getName(MessageEnum.RestAPIResponceSuccessMessage)
    );

    this.setState({ isSubmitting: false });

    if (responseJson && responseJson.data) {
      this.showMessage("Loyalty Multiplier Updated Successfully", "success");
      // Set flag to return to Loyalty Multiplier tab
      localStorage.setItem("loyaltyReturnTab", "Loyalty Multiplier");
      setTimeout(() => {
        this.props.navigation.goBack();
      }, 2000);
    } else if (responseJson && responseJson.errors) {
      this.showMessage(responseJson.errors[0] || "Failed to update multiplier", "error");
    }
  };

  receiveRuleTypes = (message: Message) => {
    const responseJson = message.getData(
      getName(MessageEnum.RestAPIResponceSuccessMessage)
    );

    if (responseJson && responseJson.data) {
      this.setState({ ruleTypes: responseJson.data });
    }
  };

  receiveMultiplierRule = (message: Message) => {
    const responseJson = message.getData(
      getName(MessageEnum.RestAPIResponceSuccessMessage)
    );

    this.setState({ isLoading: false });

    if (responseJson && responseJson.data) {
      const rule = responseJson.data.attributes;
      const config = rule.config || {};

      // Populate form data
      const formData: MultiplierFormData = {
        name: rule.name,
        description: rule.description,
        multiplier: rule.multiplier,
        loyalty_multiplier_rule_type_id: rule.rule_type.id.toString(),
        start_date: rule.start_date,
        end_date: rule.end_date || "",
        selected_days: [],
        start_time: "",
        end_time: "",
        delay_hours: "",
        special_day_name: "",
        special_day_date: "",
        is_recurring: false,
        upcharge_list_id: "",
        requires_all_items: true,
        platform_ids: [],
        region_ids: [],
        area_ids: [],
        store_ids: [],
      };

      // Populate type-specific fields
      if (rule.rule_type.id === 1) {
        formData.selected_days = config.days_of_week || [];
        formData.start_time = config.start_time || "";
        formData.end_time = config.end_time || "";
      } else if (rule.rule_type.id === 2) {
        formData.selected_days = config.applicable_days || [];
        formData.delay_hours = config.delay_hours?.toString() || "";
      } else if (rule.rule_type.id === 3) {
        formData.special_day_name = config.special_day_name || "";
        formData.special_day_date = config.special_day_date || "";
        formData.is_recurring = config.is_recurring || false;
      } else if (rule.rule_type.id === 4) {
        formData.upcharge_list_id = config.upcharge_list_id?.toString() || "";
        formData.requires_all_items = config.requires_all_items !== undefined ? config.requires_all_items : true;
      }

      // Populate days of week selection
      const selectedDays = formData.selected_days.map(dayId =>
        this.state.daysOfWeekList.find(d => d.id === dayId)
      ).filter(Boolean) as IOption[];

      // Populate sections
      const selectedSections = rule.categories.map((cat: any) => ({
        id: cat.id,
        option: cat.name
      }));

      // Populate catalogues
      const selectedCatalogues = rule.catalogues.map((cat: any) => ({
        id: cat.id,
        option: cat.name
      }));

      // Populate platforms - ensure IDs are strings to match platformList
      const selectedPlatforms = (rule.platforms || []).map((plat: any) => ({
        id: plat.id.toString(),
        option: plat.name
      }));

      // Populate regions - ensure IDs are strings to match regionList
      const selectedRegions = (rule.regions || []).map((reg: any) => ({
        id: reg.id.toString(),
        option: reg.name || reg.branch_name || `Region ${reg.id}`
      }));

      // Populate areas - ensure IDs are strings to match areaList
      const selectedAreas = (rule.areas || []).map((area: any) => ({
        id: area.id.toString(),
        option: area.area_name || area.name || `Area ${area.id}`
      }));

      // Populate stores - ensure IDs are strings to match storeList
      const selectedStores = (rule.stores || []).map((store: any) => ({
        id: store.id.toString(),
        option: store.store_name || store.name || `Store ${store.id}`
      }));

      this.setState({
        formData,
        selectedDaysOfWeek: selectedDays,
        selectedDaysOfWeekForList: selectedDays,
        sectionSelectedData: selectedSections,
        selectedSectionsForList: selectedSections,
        catalogueSelectedData: selectedCatalogues,
        selectedCataloguesForList: selectedCatalogues,
        isSectionSelectAll: rule.applies_to_all_categories && rule.categories.length === 0,
        isCatalogueSelectAll: rule.applies_to_all_catalogues && rule.catalogues.length === 0,
        platformSelectedData: selectedPlatforms,
        selectedPlatformsForList: selectedPlatforms,
        regionSelectedData: selectedRegions,
        selectedRegionsForList: selectedRegions,
        areaSelectedData: selectedAreas,
        selectedAreasForList: selectedAreas,
        storeSelectedData: selectedStores,
        selectedStoresForList: selectedStores,
      });

      // Load upcharge lists if type 4
      if (rule.rule_type.id === 4) {
        this.getUpchargeLists();
      }

      // Load sections
      this.getSections();

      // Load platforms and regions
      this.getPlatforms();
      this.getRegions();

      // Load areas if regions are selected
      if (selectedRegions.length > 0) {
        const regionIds = (rule.regions || []).map((r: any) => r.id.toString());
        this.getAreas(regionIds);
      }

      // Load stores if areas are selected and "Store" platform is selected
      if (selectedAreas.length > 0 && selectedPlatforms.some((p: any) => p.option === "Store")) {
        const areaIds = (rule.areas || []).map((a: any) => a.id.toString());
        this.getStores(areaIds);
      }
    }
  };

  async receive(from: string, message: Message) {
    this.receiveDataFromLayout(message);
    if (getName(MessageEnum.RestAPIResponceMessage) === message.id) {
      const apiRequestCallId = message.getData(
        getName(MessageEnum.RestAPIResponceDataMessage)
      );

      if (apiRequestCallId === this.getRuleTypesCallId) {
        this.receiveRuleTypes(message);
      } else if (apiRequestCallId === this.updateMultiplierCallId) {
        this.receiveUpdateMultiplier(message);
      } else if (apiRequestCallId === this.getSectionsCallId) {
        this.receiveSections(message);
      } else if (apiRequestCallId === this.getCataloguesCallId) {
        this.receiveCatalogues(message);
      } else if (apiRequestCallId === this.getUpchargeListsCallId) {
        this.receiveUpchargeLists(message);
      } else if (apiRequestCallId === this.getMultiplierRuleCallId) {
        this.receiveMultiplierRule(message);
      } else if (apiRequestCallId === this.getPlatformsCallId) {
        this.receivePlatforms(message);
      } else if (apiRequestCallId === this.getRegionsCallId) {
        this.receiveRegions(message);
      } else if (apiRequestCallId === this.getAreasCallId) {
        this.receiveAreas(message);
      } else if (apiRequestCallId === this.getStoresCallId) {
        this.receiveStores(message);
      }
    }
  }

  receiveDataFromLayout = (message: Message) => {
    if (message.id === getName(MessageEnum.LayoutDataMessage)) {
      const recievedData = message.getData(
        getName(MessageEnum.LayoutMessageData)
      );
      if (recievedData.userContext) {
        this.handleUserChange(recievedData.userContext);
      }
    }
  };

  getMultiplierRule = async (ruleId: string) => {
    const header = {
      token: await getStorageData(configJSON.tokenKey),
      "Content-Type": configJSON.contentType,
    };
    const getDataMsg = new Message(getName(MessageEnum.RestAPIRequestMessage));
    this.getMultiplierRuleCallId = getDataMsg.messageId;

    getDataMsg.addData(getName(MessageEnum.RestAPIRequestMethodMessage), "GET");
    getDataMsg.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      `bx_block_loyaltymultiplier/rules/${ruleId}`
    );
    getDataMsg.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );
    runEngine.sendMessage(getDataMsg.id, getDataMsg);
  };

  getRuleTypes = async () => {
    const header = {
      token: await getStorageData(configJSON.tokenKey),
      "Content-Type": configJSON.contentType,
    };
    const getDataMsg = new Message(getName(MessageEnum.RestAPIRequestMessage));
    this.getRuleTypesCallId = getDataMsg.messageId;

    getDataMsg.addData(getName(MessageEnum.RestAPIRequestMethodMessage), "GET");
    getDataMsg.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      "bx_block_loyaltymultiplier/rule_types"
    );
    getDataMsg.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );
    runEngine.sendMessage(getDataMsg.id, getDataMsg);
  };

  updateMultiplier = async () => {
    const header = {
      "Content-Type": configJSON.contentType,
      token: await getStorageData(configJSON.tokenKey),
    };

    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );
    this.updateMultiplierCallId = requestMessage.messageId;

    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      `bx_block_loyaltymultiplier/rules/${this.state.ruleId}`
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );

    // Get selected section and catalogue IDs
    const selectedSectionIds = this.state.isSectionSelectAll
      ? this.state.sectionList.map((s) => parseInt(s.id.toString()))
      : this.state.sectionSelectedData
          .filter((s) => s.id !== "-1")
          .map((s) => parseInt(s.id.toString()));

    const selectedCatalogueIds = this.state.isCatalogueSelectAll
      ? []
      : this.state.catalogueSelectedData
          .filter((c) => c.id !== "-1")
          .map((c) => parseInt(c.id.toString()));

    // Get selected platform IDs
    const selectedPlatformIds = this.state.isPlatformSelectAll
      ? this.state.platformList.map((p) => parseInt(p.id.toString()))
      : this.state.platformSelectedData
          .filter((p) => p.id !== "-1")
          .map((p) => parseInt(p.id.toString()));

    // Get selected region IDs
    const selectedRegionIds = this.state.isRegionSelectAll
      ? this.state.regionList.map((r) => parseInt(r.id.toString()))
      : this.state.regionSelectedData
          .filter((r) => r.id !== "-1")
          .map((r) => parseInt(r.id.toString()));

    // Get selected area IDs
    const selectedAreaIds = this.state.isAreaSelectAll
      ? this.state.areaList.map((a) => parseInt(a.id.toString()))
      : this.state.areaSelectedData
          .filter((a) => a.id !== "-1")
          .map((a) => parseInt(a.id.toString()));

    // Get selected store IDs
    const selectedStoreIds = this.state.isStoreSelectAll
      ? this.state.storeList.map((s) => parseInt(s.id.toString()))
      : this.state.storeSelectedData
          .filter((s) => s.id !== "-1")
          .map((s) => parseInt(s.id.toString()));

    const ruleTypeId = parseInt(this.state.formData.loyalty_multiplier_rule_type_id);

    // Base data that's common to all rule types
    const baseData: any = {
      loyalty_multiplier_rule_type_id: ruleTypeId,
      name: this.state.formData.name,
      description: this.state.formData.description,
      multiplier: parseFloat(this.state.formData.multiplier),
      is_active: true,
      priority: 10,
      start_date: this.state.formData.start_date,
      end_date: this.state.formData.end_date || null,
      category_ids: selectedSectionIds,
      catalogue_ids: selectedCatalogueIds,
      platform_ids: selectedPlatformIds,
      region_ids: selectedRegionIds,
      area_ids: selectedAreaIds,
      store_ids: selectedStoreIds
    };

    // Add type-specific config based on rule type
    if (ruleTypeId === 1) {
      // Type 1: Day Time Config
      baseData.day_time_config = {
        days_of_week: this.state.formData.selected_days,
        start_time: this.state.formData.start_time,
        end_time: this.state.formData.end_time
      };
    } else if (ruleTypeId === 2) {
      // Type 2: Late Delivery Config
      baseData.late_delivery_config = {
        delay_hours: parseInt(this.state.formData.delay_hours),
        applicable_days: this.state.formData.selected_days
      };
    } else if (ruleTypeId === 3) {
      // Type 3: Special Day Config
      baseData.special_day_config = {
        special_day_name: this.state.formData.special_day_name,
        special_day_date: this.state.formData.special_day_date,
        is_recurring: this.state.formData.is_recurring
      };
    } else if (ruleTypeId === 4) {
      // Type 4: Upcharge Config
      baseData.upcharge_config = {
        upcharge_list_id: parseInt(this.state.formData.upcharge_list_id),
        requires_all_items: this.state.formData.requires_all_items
      };
    } else {
      // Default config for other types
      baseData.day_time_config = {
        days_of_week: [],
        start_time: "",
        end_time: ""
      };
    }

    const datas = baseData;

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestBodyMessage),
      JSON.stringify({ data: datas })
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      "PUT"
    );

    runEngine.sendMessage(requestMessage.id, requestMessage);
  };

  onCancel = () => {
    // Set flag to return to Loyalty Multiplier tab
    localStorage.setItem("loyaltyReturnTab", "Loyalty Multiplier");
    this.props.navigation.goBack();
  };

  checkFormErrors = () => {
    const { formData } = this.state;
    const formErrors: { [key: string]: string } = {};

    if (!formData.name.trim()) {
      formErrors["name"] = "Name is required";
    }
    if (!formData.description.trim()) {
      formErrors["description"] = "Description is required";
    }
    if (!formData.multiplier || parseFloat(formData.multiplier) <= 0) {
      formErrors["multiplier"] = "Multiplier must be greater than 0";
    }
    if (!formData.loyalty_multiplier_rule_type_id) {
      formErrors["loyalty_multiplier_rule_type_id"] = "Rule type is required";
    }
    if (!formData.start_date) {
      formErrors["start_date"] = "Start date is required";
    }

    this.setState({ formErrors });
    return Object.keys(formErrors).length === 0;
  };

  onSave = () => {
    if (this.checkFormErrors()) {
      this.setState({ isSubmitting: true });
      this.updateMultiplier();
    }
  };

  async componentDidMount() {
    super.componentDidMount();
    const ruleId = localStorage.getItem("loyaltyMultiplierId") || "";
    this.setState({ ruleId }, () => {
      if (ruleId) {
        this.getMultiplierRule(ruleId);
      }
    });
    this.getRuleTypes();
  }

  showMessage = (message: string, type: "error" | "success" | "info" | "warning") => {
    this.setState({ snackBarMessage: message, snackBarMessageType: type });
  };

  closeSnackBar = () => {
    this.setState({ snackBarMessage: "", snackBarMessageType: undefined });
  };

  handleUserChange = (userContext: IUserContext) => {
    const apiKey = customPermissionApiKey.loyaltySystem;
    const userData = userContext.user?.attributes.permission_groups;
    const value = checkForNewPermissonStatus(apiKey, userData as Array<PermissionGroupArray>);
    this.setState({
      permissionStatus: value,
      isLoadingPermission: false
    });
  };

  handleInputChange = (field: keyof MultiplierFormData, value: string) => {
    this.setState({
      formData: {
        ...this.state.formData,
        [field]: value,
      },
      formErrors: {
        ...this.state.formErrors,
        [field]: "",
      },
    });
  };

  handleRuleTypeChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    const ruleTypeId = event.target.value as string;
    this.handleInputChange("loyalty_multiplier_rule_type_id", ruleTypeId);

    // Load upcharge lists if rule type is 4
    if (ruleTypeId === "4") {
      this.getUpchargeLists();
    }
  };

  getSections = async () => {
    const header = {
      token: await getStorageData(configJSON.tokenKey),
      "Content-Type": configJSON.contentType,
    };
    const getDataMsg = new Message(getName(MessageEnum.RestAPIRequestMessage));
    this.getSectionsCallId = getDataMsg.messageId;

    getDataMsg.addData(getName(MessageEnum.RestAPIRequestMethodMessage), "GET");
    getDataMsg.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      "bx_block_categories/categories?dropdown=true"
    );
    getDataMsg.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );
    runEngine.sendMessage(getDataMsg.id, getDataMsg);
  };

  receiveSections = (message: Message) => {
    const responseJson = message.getData(
      getName(MessageEnum.RestAPIResponceSuccessMessage)
    );

    if (responseJson && responseJson.data) {
      const sectionList = responseJson.data.map((item: any) => ({
        id: item.id,
        option: item.attributes.section_name || item.attributes.name,
      }));
      this.setState({ sectionList });
    }
  };

  getCatalogues = async (sectionIds: string[] = [], pageNo: number = 1, searchQuery: string = "") => {
    const header = {
      token: await getStorageData(configJSON.tokenKey),
      "Content-Type": configJSON.contentType,
    };

    // Build the endpoint with section filter
    let endpoint = "bx_block_catalogue/catalogues?dropdown=true";
    if (sectionIds.length > 0) {
      const sectionFilter = sectionIds.join(",");
      endpoint += `&filter_by[section_ids]=${sectionFilter}`;
    }

    // Add search query if provided
    if (searchQuery) {
      endpoint += `&filter_by[query]=${searchQuery}`;
    }

    // Add pagination
    endpoint += `&page_no=${pageNo}&per_page=20`;

    const getDataMsg = new Message(getName(MessageEnum.RestAPIRequestMessage));
    this.getCataloguesCallId = getDataMsg.messageId;

    getDataMsg.addData(getName(MessageEnum.RestAPIRequestMethodMessage), "GET");
    getDataMsg.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      endpoint
    );
    getDataMsg.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );

    this.isLoadingMoreCatalogues = pageNo > 1;
    runEngine.sendMessage(getDataMsg.id, getDataMsg);
  };

  receiveCatalogues = (message: Message) => {
    const responseJson = message.getData(
      getName(MessageEnum.RestAPIResponceSuccessMessage)
    );

    if (responseJson && responseJson.data) {
      const newCatalogues = responseJson.data.map((item: any) => ({
        id: item.id,
        option: item.attributes.product_name || item.attributes.name,
      }));

      // Handle pagination - append or replace based on page number
      let catalogueList: IOption[];

      if (this.catalogueNextPage === 1) {
        // First page - replace existing catalogues
        catalogueList = newCatalogues;
      } else {
        // Subsequent pages - append to existing catalogues
        catalogueList = [...this.state.catalogueList, ...newCatalogues];
      }

      // Check if there are more catalogues to load
      const hasMoreCatalogues = newCatalogues.length === 20; // Assuming page size is 20

      this.setState({ catalogueList });

      // Update pagination state
      this.hasMoreCatalogues = hasMoreCatalogues;
      this.isLoadingMoreCatalogues = false;
      if (hasMoreCatalogues) {
        this.catalogueNextPage += 1;
      }
    } else {
      this.isLoadingMoreCatalogues = false;
      this.hasMoreCatalogues = false;
    }
  };

  updateMultiSelectData = (
    newItems: IOption[],
    totalList: IOption[],
    isSelectAll: boolean
  ) => {
    if (newItems.length === totalList.length) {
      return {
        isSelectAll: true,
        selectedData: [{ id: "-1", option: "Select All" }],
        selectedForList: [{ id: "-1", option: "Select All" }, ...totalList],
      };
    }
    return {
      isSelectAll: false,
      selectedData: newItems,
      selectedForList: newItems,
    };
  };

  handleSectionMultiSelect = (value: IOption[], option: IOption) => {
    let updateStateData: Partial<S> = {};

    if (option.id === "-1") {
      // Handle "Select All" toggle
      updateStateData = this.state.isSectionSelectAll
        ? {
            isSectionSelectAll: false,
            sectionSelectedData: [],
            selectedSectionsForList: [],
            catalogueList: [],
            catalogueSelectedData: [],
            selectedCataloguesForList: [],
          }
        : {
            isSectionSelectAll: true,
            sectionSelectedData: [{ id: "-1", option: "Select All" }],
            selectedSectionsForList: [
              { id: "-1", option: "Select All" },
              ...this.state.sectionList,
            ],
          };
    } else {
      // Handle individual selection
      const isValueContained = value.some((item) => item.id === option.id);
      const filteredValue = value.filter((item) => item.id !== "-1");
      const newItems = isValueContained
        ? filteredValue.filter((item) => item.id !== option.id)
        : [...filteredValue, option];

      const result = this.updateMultiSelectData(
        newItems,
        this.state.sectionList,
        this.state.isSectionSelectAll
      );

      updateStateData = {
        isSectionSelectAll: result.isSelectAll,
        sectionSelectedData: result.selectedData,
        selectedSectionsForList: result.selectedForList,
      };
    }

    this.setState(updateStateData as Pick<S, keyof S>, () => {
      // Load catalogues when sections are selected
      const selectedSectionIds = this.state.isSectionSelectAll
        ? this.state.sectionList.map((s) => s.id.toString())
        : this.state.sectionSelectedData
            .filter((s) => s.id !== "-1")
            .map((s) => s.id.toString());

      if (selectedSectionIds.length > 0) {
        // Reset pagination and load first page
        this.catalogueNextPage = 1;
        this.catalogueSearchQuery = "";
        this.hasMoreCatalogues = true;
        this.getCatalogues(selectedSectionIds, 1, "");
      } else {
        this.setState({
          catalogueList: [],
          catalogueSelectedData: [],
          selectedCataloguesForList: [],
        });
      }
    });
  };

  handleCatalogueMultiSelect = (value: IOption[], option: IOption) => {
    let updateStateData: Partial<S> = {};

    if (option.id === "-1") {
      // Handle "Select All" toggle
      updateStateData = this.state.isCatalogueSelectAll
        ? {
            isCatalogueSelectAll: false,
            catalogueSelectedData: [],
            selectedCataloguesForList: [],
          }
        : {
            isCatalogueSelectAll: true,
            catalogueSelectedData: [{ id: "-1", option: "Select All" }],
            selectedCataloguesForList: [
              { id: "-1", option: "Select All" },
              ...this.state.catalogueList,
            ],
          };
    } else {
      // Handle individual selection
      const isValueContained = value.some((item) => item.id === option.id);
      const filteredValue = value.filter((item) => item.id !== "-1");
      const newItems = isValueContained
        ? filteredValue.filter((item) => item.id !== option.id)
        : [...filteredValue, option];

      const result = this.updateMultiSelectData(
        newItems,
        this.state.catalogueList,
        this.state.isCatalogueSelectAll
      );

      updateStateData = {
        isCatalogueSelectAll: result.isSelectAll,
        catalogueSelectedData: result.selectedData,
        selectedCataloguesForList: result.selectedForList,
      };
    }

    this.setState(updateStateData as Pick<S, keyof S>);
  };

  handleCatalogueScroll = () => {
    if (!this.isLoadingMoreCatalogues && this.hasMoreCatalogues) {
      const selectedSectionIds = this.state.isSectionSelectAll
        ? this.state.sectionList.map((s) => s.id.toString())
        : this.state.sectionSelectedData
            .filter((s) => s.id !== "-1")
            .map((s) => s.id.toString());

      if (selectedSectionIds.length > 0) {
        this.getCatalogues(selectedSectionIds, this.catalogueNextPage, this.catalogueSearchQuery);
      }
    }
  };

  handleCatalogueSearch = (searchQuery: string) => {
    this.catalogueSearchQuery = searchQuery;
    this.catalogueNextPage = 1;
    this.hasMoreCatalogues = true;

    const selectedSectionIds = this.state.isSectionSelectAll
      ? this.state.sectionList.map((s) => s.id.toString())
      : this.state.sectionSelectedData
          .filter((s) => s.id !== "-1")
          .map((s) => s.id.toString());

    if (selectedSectionIds.length > 0) {
      this.getCatalogues(selectedSectionIds, 1, searchQuery);
    }
  };

  getUpchargeLists = async () => {
    const header = {
      token: await getStorageData(configJSON.tokenKey),
      "Content-Type": configJSON.contentType,
    };
    const getDataMsg = new Message(getName(MessageEnum.RestAPIRequestMessage));
    this.getUpchargeListsCallId = getDataMsg.messageId;

    getDataMsg.addData(getName(MessageEnum.RestAPIRequestMethodMessage), "GET");
    getDataMsg.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      "bx_block_section/upcharge_lists?page_no=1&per_page=10&skip_extra_attribute=true"
    );
    getDataMsg.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );
    runEngine.sendMessage(getDataMsg.id, getDataMsg);
  };

  receiveUpchargeLists = (message: Message) => {
    const responseJson = message.getData(
      getName(MessageEnum.RestAPIResponceSuccessMessage)
    );

    if (responseJson && responseJson.data) {
      this.setState({ upchargeList: responseJson.data });
    }
  };

  handleDaysOfWeekMultiSelect = (value: IOption[], option: IOption) => {
    const isValueContained = value.some((item) => item.id === option.id);
    const newItems = isValueContained
      ? value.filter((item) => item.id !== option.id)
      : [...value, option];

    this.setState({
      selectedDaysOfWeek: newItems,
      selectedDaysOfWeekForList: newItems,
      formData: {
        ...this.state.formData,
        selected_days: newItems.map((item) => Number(item.id)),
      },
    });
  };

  // Platform multi-select handler
  handlePlatformMultiSelect = (value: IOption[], option: IOption) => {
    let updateStateData: Partial<S> = {};

    if (option.id === "-1") {
      // Handle "Select All" toggle
      updateStateData = this.state.isPlatformSelectAll
        ? {
            isPlatformSelectAll: false,
            platformSelectedData: [],
            selectedPlatformsForList: [],
            storeList: [],
            storeSelectedData: [],
            selectedStoresForList: [],
            isStoreSelectAll: false,
          }
        : {
            isPlatformSelectAll: true,
            platformSelectedData: [{ id: "-1", option: "Select All" }],
            selectedPlatformsForList: [
              { id: "-1", option: "Select All" },
              ...this.state.platformList.map((p) => ({ id: p.id, option: p.attributes.name })),
            ],
          };
    } else {
      // Handle individual selection
      const isValueContained = value.some((item) => item.id === option.id);
      const filteredValue = value.filter((item) => item.id !== "-1");
      const newItems = isValueContained
        ? filteredValue.filter((item) => item.id !== option.id)
        : [...filteredValue, option];

      const platformOptions = this.state.platformList.map((p) => ({ id: p.id, option: p.attributes.name }));
      const result = this.updateMultiSelectData(
        newItems,
        platformOptions,
        this.state.isPlatformSelectAll
      );

      updateStateData = {
        isPlatformSelectAll: result.isSelectAll,
        platformSelectedData: result.selectedData,
        selectedPlatformsForList: result.selectedForList,
      };
    }

    this.setState(updateStateData as Pick<S, keyof S>, () => {
      // Load stores if "Store" platform is selected
      const selectedPlatforms = this.state.isPlatformSelectAll
        ? this.state.platformList
        : this.state.platformSelectedData
            .filter((p) => p.id !== "-1")
            .map((p) => this.state.platformList.find((pl) => pl.id === p.id))
            .filter(Boolean) as IPlatform[];

      const hasStorePlatform = selectedPlatforms.some((p) => p.attributes.name === "Store");

      if (!hasStorePlatform) {
        this.setState({
          storeList: [],
          storeSelectedData: [],
          selectedStoresForList: [],
          isStoreSelectAll: false,
        });
      } else {
        // Load stores if areas are selected
        const selectedAreaIds = this.state.isAreaSelectAll
          ? this.state.areaList.map((a) => a.id.toString())
          : this.state.areaSelectedData
              .filter((a) => a.id !== "-1")
              .map((a) => a.id.toString());

        if (selectedAreaIds.length > 0) {
          this.getStores(selectedAreaIds);
        }
      }
    });
  };

  // Region multi-select handler
  handleRegionMultiSelect = (value: IOption[], option: IOption) => {
    let updateStateData: Partial<S> = {};

    if (option.id === "-1") {
      // Handle "Select All" toggle
      updateStateData = this.state.isRegionSelectAll
        ? {
            isRegionSelectAll: false,
            regionSelectedData: [],
            selectedRegionsForList: [],
            areaList: [],
            areaSelectedData: [],
            selectedAreasForList: [],
            isAreaSelectAll: false,
            storeList: [],
            storeSelectedData: [],
            selectedStoresForList: [],
            isStoreSelectAll: false,
          }
        : {
            isRegionSelectAll: true,
            regionSelectedData: [{ id: "-1", option: "Select All" }],
            selectedRegionsForList: [
              { id: "-1", option: "Select All" },
              ...this.state.regionList.map((r) => ({ id: r.id, option: r.attributes.name })),
            ],
          };
    } else {
      // Handle individual selection
      const isValueContained = value.some((item) => item.id === option.id);
      const filteredValue = value.filter((item) => item.id !== "-1");
      const newItems = isValueContained
        ? filteredValue.filter((item) => item.id !== option.id)
        : [...filteredValue, option];

      const regionOptions = this.state.regionList.map((r) => ({ id: r.id, option: r.attributes.name }));
      const result = this.updateMultiSelectData(
        newItems,
        regionOptions,
        this.state.isRegionSelectAll
      );

      updateStateData = {
        isRegionSelectAll: result.isSelectAll,
        regionSelectedData: result.selectedData,
        selectedRegionsForList: result.selectedForList,
      };
    }

    this.setState(updateStateData as Pick<S, keyof S>, () => {
      // Load areas when regions are selected
      const selectedRegionIds = this.state.isRegionSelectAll
        ? this.state.regionList.map((r) => r.id.toString())
        : this.state.regionSelectedData
            .filter((r) => r.id !== "-1")
            .map((r) => r.id.toString());

      if (selectedRegionIds.length > 0) {
        this.getAreas(selectedRegionIds);
      } else {
        this.setState({
          areaList: [],
          areaSelectedData: [],
          selectedAreasForList: [],
          isAreaSelectAll: false,
          storeList: [],
          storeSelectedData: [],
          selectedStoresForList: [],
          isStoreSelectAll: false,
        });
      }
    });
  };

  // Area multi-select handler
  handleAreaMultiSelect = (value: IOption[], option: IOption) => {
    let updateStateData: Partial<S> = {};

    if (option.id === "-1") {
      // Handle "Select All" toggle
      updateStateData = this.state.isAreaSelectAll
        ? {
            isAreaSelectAll: false,
            areaSelectedData: [],
            selectedAreasForList: [],
            storeList: [],
            storeSelectedData: [],
            selectedStoresForList: [],
            isStoreSelectAll: false,
          }
        : {
            isAreaSelectAll: true,
            areaSelectedData: [{ id: "-1", option: "Select All" }],
            selectedAreasForList: [
              { id: "-1", option: "Select All" },
              ...this.state.areaList.map((a) => ({ id: a.id, option: a.attributes.area_name })),
            ],
          };
    } else {
      // Handle individual selection
      const isValueContained = value.some((item) => item.id === option.id);
      const filteredValue = value.filter((item) => item.id !== "-1");
      const newItems = isValueContained
        ? filteredValue.filter((item) => item.id !== option.id)
        : [...filteredValue, option];

      const areaOptions = this.state.areaList.map((a) => ({ id: a.id, option: a.attributes.area_name }));
      const result = this.updateMultiSelectData(
        newItems,
        areaOptions,
        this.state.isAreaSelectAll
      );

      updateStateData = {
        isAreaSelectAll: result.isSelectAll,
        areaSelectedData: result.selectedData,
        selectedAreasForList: result.selectedForList,
      };
    }

    this.setState(updateStateData as Pick<S, keyof S>, () => {
      // Load stores if "Store" platform is selected and areas are selected
      const selectedPlatforms = this.state.isPlatformSelectAll
        ? this.state.platformList
        : this.state.platformSelectedData
            .filter((p) => p.id !== "-1")
            .map((p) => this.state.platformList.find((pl) => pl.id === p.id))
            .filter(Boolean) as IPlatform[];

      const hasStorePlatform = selectedPlatforms.some((p) => p.attributes.name === "Store");

      if (hasStorePlatform) {
        const selectedAreaIds = this.state.isAreaSelectAll
          ? this.state.areaList.map((a) => a.id.toString())
          : this.state.areaSelectedData
              .filter((a) => a.id !== "-1")
              .map((a) => a.id.toString());

        if (selectedAreaIds.length > 0) {
          this.getStores(selectedAreaIds);
        } else {
          this.setState({
            storeList: [],
            storeSelectedData: [],
            selectedStoresForList: [],
            isStoreSelectAll: false,
          });
        }
      }
    });
  };

  // Store multi-select handler
  handleStoreMultiSelect = (value: IOption[], option: IOption) => {
    let updateStateData: Partial<S> = {};

    if (option.id === "-1") {
      // Handle "Select All" toggle
      updateStateData = this.state.isStoreSelectAll
        ? {
            isStoreSelectAll: false,
            storeSelectedData: [],
            selectedStoresForList: [],
          }
        : {
            isStoreSelectAll: true,
            storeSelectedData: [{ id: "-1", option: "Select All" }],
            selectedStoresForList: [
              { id: "-1", option: "Select All" },
              ...this.state.storeList.map((s) => ({ id: s.id, option: s.attributes.store_name })),
            ],
          };
    } else {
      // Handle individual selection
      const isValueContained = value.some((item) => item.id === option.id);
      const filteredValue = value.filter((item) => item.id !== "-1");
      const newItems = isValueContained
        ? filteredValue.filter((item) => item.id !== option.id)
        : [...filteredValue, option];

      const storeOptions = this.state.storeList.map((s) => ({ id: s.id, option: s.attributes.store_name }));
      const result = this.updateMultiSelectData(
        newItems,
        storeOptions,
        this.state.isStoreSelectAll
      );

      updateStateData = {
        isStoreSelectAll: result.isSelectAll,
        storeSelectedData: result.selectedData,
        selectedStoresForList: result.selectedForList,
      };
    }

    this.setState(updateStateData as Pick<S, keyof S>);
  };

  // Platform, Region, Area, Store API calls
  getPlatforms = async () => {
    const header = {
      token: await getStorageData(configJSON.tokenKey),
      "Content-Type": configJSON.contentType,
    };
    const getDataMsg = new Message(getName(MessageEnum.RestAPIRequestMessage));
    this.getPlatformsCallId = getDataMsg.messageId;

    getDataMsg.addData(getName(MessageEnum.RestAPIRequestMethodMessage), "GET");
    getDataMsg.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      "bx_block_promo_codes/promo_codes/platform_listing"
    );
    getDataMsg.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );
    runEngine.sendMessage(getDataMsg.id, getDataMsg);
  };

  getRegions = async () => {
    const header = {
      token: await getStorageData(configJSON.tokenKey),
      "Content-Type": configJSON.contentType,
    };
    const getDataMsg = new Message(getName(MessageEnum.RestAPIRequestMessage));
    this.getRegionsCallId = getDataMsg.messageId;

    getDataMsg.addData(getName(MessageEnum.RestAPIRequestMethodMessage), "GET");
    getDataMsg.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      "bx_block_regions/regions?dropdown=true"
    );
    getDataMsg.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );
    runEngine.sendMessage(getDataMsg.id, getDataMsg);
  };

  getAreas = async (regionIds: string[] = []) => {
    if (regionIds.length === 0) {
      this.setState({
        areaList: [],
        areaSelectedData: [],
        selectedAreasForList: [],
        isAreaSelectAll: false,
        storeList: [],
        storeSelectedData: [],
        selectedStoresForList: [],
        isStoreSelectAll: false,
      });
      return;
    }

    const header = {
      token: await getStorageData(configJSON.tokenKey),
      "Content-Type": configJSON.contentType,
    };

    let endpoint = "bx_block_regions/areas?dropdown=true";
    regionIds.forEach((id) => {
      endpoint += `&region_id[]=${id}`;
    });

    const getDataMsg = new Message(getName(MessageEnum.RestAPIRequestMessage));
    this.getAreasCallId = getDataMsg.messageId;

    getDataMsg.addData(getName(MessageEnum.RestAPIRequestMethodMessage), "GET");
    getDataMsg.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      endpoint
    );
    getDataMsg.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );
    runEngine.sendMessage(getDataMsg.id, getDataMsg);
  };

  getStores = async (areaIds: string[] = []) => {
    if (areaIds.length === 0) {
      this.setState({
        storeList: [],
        storeSelectedData: [],
        selectedStoresForList: [],
        isStoreSelectAll: false,
      });
      return;
    }

    const header = {
      token: await getStorageData(configJSON.tokenKey),
      "Content-Type": configJSON.contentType,
    };

    let endpoint = "bx_block_store_management/store_managements?dropdown=true&allow_access=true";
    areaIds.forEach((id) => {
      endpoint += `&area_id[]=${id}`;
    });

    const getDataMsg = new Message(getName(MessageEnum.RestAPIRequestMessage));
    this.getStoresCallId = getDataMsg.messageId;

    getDataMsg.addData(getName(MessageEnum.RestAPIRequestMethodMessage), "GET");
    getDataMsg.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      endpoint
    );
    getDataMsg.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );
    runEngine.sendMessage(getDataMsg.id, getDataMsg);
  };

  receivePlatforms = (message: Message) => {
    const responseJson = message.getData(
      getName(MessageEnum.RestAPIResponceSuccessMessage)
    );

    if (responseJson && responseJson.data) {
      this.setState({ platformList: responseJson.data });
    }
  };

  receiveRegions = (message: Message) => {
    const responseJson = message.getData(
      getName(MessageEnum.RestAPIResponceSuccessMessage)
    );

    if (responseJson && responseJson.data) {
      this.setState({ regionList: responseJson.data });
    }
  };

  receiveAreas = (message: Message) => {
    const responseJson = message.getData(
      getName(MessageEnum.RestAPIResponceSuccessMessage)
    );

    if (responseJson && responseJson.data) {
      const areaList = responseJson.data;
      this.setState({ areaList });
    }
  };

  receiveStores = (message: Message) => {
    const responseJson = message.getData(
      getName(MessageEnum.RestAPIResponceSuccessMessage)
    );

    if (responseJson && responseJson.data) {
      const storeList = responseJson.data;
      this.setState({ storeList });
    }
  };

  // Customizable Area End
}
